import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export const api = axios.create({
    baseURL: `${BACKEND_URL}/api`,
});

api.interceptors.request.use((config) => {
    const token = localStorage.getItem("showtime_admin_token");
    if (token) {
        config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
});

export const retailerApi = axios.create({
    baseURL: `${BACKEND_URL}/api`,
});

retailerApi.interceptors.request.use((config) => {
    const token = localStorage.getItem("showtime_retailer_token");
    if (token) {
        config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
});

export const formatApiError = (detail) => {
    if (detail == null) return "Something went wrong. Please try again.";
    if (typeof detail === "string") return detail;
    if (Array.isArray(detail)) return detail.map((e) => e?.msg || JSON.stringify(e)).join(" ");
    return detail?.msg || String(detail);
};
